// services/mailingService.js
import { ConstantService } from 'src/constants/apiPaths';
import { API_METHODS, useData, useMutation } from '.';

// Custom hooks for each endpoint

export function useJoinRolzo() {
  const { updateData, loading } = useMutation(ConstantService.apiRoutes.joinRolzo);

  // Function to call the joinRolzo API
  const joinRolzo = async (data) => {
    try {
      return await updateData(data, API_METHODS.POST);
    } catch (error) {
      throw error;
    }
  };

  return {
    joinRolzo,
    loading,
  };
}

export function useAddBusinessAccount() {
  const { updateData, loading } = useMutation(ConstantService.apiRoutes.businessAccount);

  // Function to call the addBusinessAccount API
  const addBusinessAccount = async (data) => {
    try {
      return await updateData(data, API_METHODS.POST);
    } catch (error) {
      throw error;
    }
  };

  return {
    addBusinessAccount,
    loading,
  };
}

export function useAddEventsAccount() {
  const { updateData, loading } = useMutation(ConstantService.apiRoutes.eventsAccount);

  // Function to call the addEventsAccount API
  const addEventsAccount = async (data) => {
    try {
      return await updateData(data, API_METHODS.POST);
    } catch (error) {
      throw error;
    }
  };

  return {
    addEventsAccount,
    loading,
  };
}
export function useAddPriveAccount() {
  const { updateData, loading } = useMutation(ConstantService.apiRoutes.priveAccount);

  // Function to call the addEventsAccount API
  const addPriveAccount = async (data) => {
    try {
      return await updateData(data, API_METHODS.POST);
    } catch (error) {
      throw error;
    }
  };

  return {
    addPriveAccount,
    loading,
  };
}

export function useAddRolzoApiAccount() {
  const { updateData, loading } = useMutation(ConstantService.apiRoutes.rolzoApiAccount);

  // Function to call the addRolzoApiAccount API
  const addRolzoApiAccount = async (data) => {
    try {
      return await updateData(data, API_METHODS.POST);
    } catch (error) {
      throw error;
    }
  };

  return {
    addRolzoApiAccount,
    loading,
  };
}

// Optional: Server-side function for direct calls
export async function addRolzoApiAccountServer(data) {
  const { updateData } = useMutation(ConstantService.apiRoutes.rolzoApiAccount);
  try {
    return await updateData(data, API_METHODS.POST);
  } catch (error) {
    throw error;
  }
}
